module.exports = __webpack_public_path__ + "img/853217f.svg";